import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {AppSettings} from '../../../app-settings';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {DataManagementService} from '../../services/data-management.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import {Constants} from '../../constants';
import {University} from '../../model/university';
import * as moment from 'moment';
import {Subject} from 'rxjs/Subject';
import {Router} from '@angular/router';
import {AccessService} from '../../services/access.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-universities',
    templateUrl: './universities.component.html',
    styleUrls: ['./universities.component.css']
})
export class UniversitiesComponent implements OnInit {
    @ViewChild('uploadUniversitiesModal') uploadUniversitiesModal: TemplateRef<any>;
    @ViewChild('addEditUniversityModal') addEditUniversityModal: TemplateRef<any>;
	@ViewChild('additionalInfoModal') additionalInfoModal: TemplateRef<any>;
	downloadDocument = AppSettings.JAVA_API + AppSettings.DOWNLOAD_FACTSHEET_DOCUMENT;
    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    universitiesTemplate = AppSettings.UNIVERSITY_TEMPLATE;
    public modalReference: NgbModalRef;
    universities: University[];
    data: object;
    errorMessage: string = undefined;
    oneUniversity;
    poc = [];
    country;
    continent;
    ObjectKeys = Object.keys;
    editUniversityFlag;
    fileList: FileList;
    factSheet = Constants.FACTSHEET;
    mou = Constants.MOU;

    constructor(private modal: NgbModal,
                private router: Router,
                private dmService: DataManagementService,
                private accessService: AccessService,
                private toastr: ToastrService) {
    }

    getUniversities() {
        this.dmService.getAll(Constants.UNIVERSITY)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.universities = response.data;
                        if (this.universities.length === 0) {
                            this.errorMessage = 'There is no data available for universities.';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team.';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    fileChange(evt) {
        const target: DataTransfer = <DataTransfer>(evt.target);
        if (target.files.length !== 1) {
            throw new Error('Cannot upload multiple files on the entry');
        }
        const reader = new FileReader();
        reader.onload = (e: any) => {
            /* read workbook */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, {type: 'binary'});
            /* grab first sheet */
            const wsName = wb.SheetNames[0];
            const ws = wb.Sheets[wsName];
            /* save data */
            this.data = XLSX.utils.sheet_to_json(ws,
                {
                    header: ['university_name', 'country', 'continent', 'address', 'min_cgpa', 'min_work_experience',
                        'incoming_count', 'outgoing_count', 'fs_link', 'mou_expiry_date', 'year', 'additional_information',
                        'primary_poc_name', 'primary_poc_salutation', 'primary_poc_role', 'primary_poc_mobile', 'primary_poc_fax',
                        'primary_poc_email', 'secondary_poc_name', 'secondary_poc_salutation', 'secondary_poc_role',
                        'secondary_poc_mobile', 'secondary_poc_fax', 'secondary_poc_email'], range: 1
                });
        };
        reader.readAsBinaryString(target.files[0]);
        return this.data;
    }

    fileChangeForDocumentUpload(event) {
        if (event.target.files.length !== 1) {
            throw new Error('Cannot upload multiple files on the entry');
        }
        this.fileList = event.target.files;
    }

    uploadDocument(documentId) {
        if (this.fileList.length === 1) {
            const userId = JSON.parse(localStorage.getItem('epas_user')).user_id;
            const file: File = this.fileList[0];
            const formData: FormData = new FormData();
            formData.append('file', file);
            formData.append('university_id', this.oneUniversity.university_id);
            formData.append('document_type_id', documentId);
            formData.append('user_id', userId);
            this.dmService.javaUploadFSOrMOUFile(formData).subscribe(response => {
                if (response.status === 'success') {
                    this.fileList = undefined;
                    this.toastr.success('Successfully uploaded the file ' + file.name, 'Success');
                    this.modalReference.close();
                    this.openUniversityEditModal(this.oneUniversity);
                } else if (response.status === 'fail') {
                    if (response.hasOwnProperty('message')) {
                        this.toastr.warning(response.message, 'Fail');
                    } else {
                        this.toastr.warning('Something went wrong. please contact support team', 'Fail');
                    }
                    this.errorMessage = response.message;
                }
            }, error => {
                console.log(error);
                this.toastr.warning('Something went wrong. please contact support team', 'Fail');
                this.errorMessage = 'Server Error';
            });
        }

    }

    deleteDocument(documentId) {
        const finalData = {
            university_id: this.oneUniversity.university_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        if (documentId === Constants.FACTSHEET) {
            finalData['document_id'] = this.oneUniversity.fact_sheet_id;
            finalData['document_type_id'] = Constants.FACTSHEET;
        } else {
            finalData['document_id'] = this.oneUniversity.mou_id;
            finalData['document_type_id'] = Constants.MOU;
        }
        this.dmService.javaPostDataCall(finalData, Constants.UNIVERSITY).subscribe(response => {
            if (response.status === 'success') {
                this.fileList = undefined;
                this.toastr.success('Successfully deleted the file ', 'Success');
                this.modalReference.close();
                this.openUniversityEditModal(this.oneUniversity);
            } else if (response.status === 'fail') {
                if (response.hasOwnProperty('message')) {
                    this.toastr.warning(response.message, 'Fail');
                } else {
                    this.toastr.warning('Something went wrong. please contact support team', 'Fail');
                }
                this.errorMessage = response.message;
            }
        }, error => {
            console.log(error);
            this.toastr.warning('Something went wrong. please contact support team', 'Fail');
            this.errorMessage = 'Server Error';
        });

    }

    getDate(date): string {
        if (date === undefined || date === null || date === '' || date === 'undefined') {
            return '';
        }
        return moment(date).format('Do MMM YYYY');
    }

    uploadUniversities(e) {
        e.preventDefault();
        const finalUploadData = {
            data: this.data,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        const that = this;
        let uploadResponse;
        Swal({
            title: 'Confirm',
            type: 'question',
            text: 'You are going to upload ' + Object.keys(this.data).length + ' Universities?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#4cb84c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.bulkUpload(finalUploadData, Constants.UNIVERSITY).subscribe(data => {
                        uploadResponse = data;
                        resolve(uploadResponse);
                    }, error => {
                        uploadResponse = error;
                        reject(uploadResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (uploadResponse.status === 'success') {
                    that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
                        that.router.navigate(['data/universities']));
                    if (uploadResponse.data.hasOwnProperty('message')) {
                        Swal({
                            title: 'Success',
                            type: 'success',
                            html: uploadResponse.data.message,
                        });
                    } else {
                        Swal({
                            title: 'Success',
                            type: 'success',
                            html: '<p>Successfully uploaded Universities.</p>',
                        });
                    }
                    that.closeModal();
                } else if (uploadResponse.status === 'fail') {
                    if (uploadResponse.data.hasOwnProperty('message')) {
                        Swal({type: 'error', title: 'Fail', html: uploadResponse.data.message});
                    } else {
                        Swal({type: 'error', title: 'Fail', text: 'Unable to upload Universities, Please contact support team.'});
                    }
                }
            }
        });
    }

    clearUniversities(): void {
        Swal({
            title: 'Confirm',
            type: 'question',
            text: 'You are going to Clear Universities?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-warning rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#4cb84c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
        });
    }

    addPOC(university, event: Event): void {
        event.preventDefault();
        if (!this.oneUniversity.hasOwnProperty('poc')) {
            this.oneUniversity.poc = [];
        }
        this.oneUniversity.poc[this.oneUniversity.poc.length] = {};
    }

    deletePOC(poc, event: Event) {
        event.preventDefault();
        if (poc.hasOwnProperty('poc_id')) {
            const finalData = {
                poc_id: poc.poc_id,
                email: poc.email,
                user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
            };
            const that = this;
            let deletePOCResponse;
            Swal({
                title: 'confirm',
                type: 'question',
                html: '<p>Do you want to delete <span style="font-weight: bold">' + poc.name + '</span> poc?</p>',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-outline-success rounded-0',
                cancelButtonClass: 'btn btn-outline-danger rounded-0',
                cancelButtonColor: '#d33',
                confirmButtonColor: '#5cb85c',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showLoaderOnConfirm: true,
                preConfirm: function () {
                    return new Promise(function (resolve, reject) {
                        that.dmService.clearDataByParameter(finalData, Constants.DELETE_POC).subscribe(data => {
                            deletePOCResponse = data;
                            resolve(deletePOCResponse);
                        }, error => {
                            deletePOCResponse = error;
                            reject(deletePOCResponse);
                        });
                    });
                },
                allowOutsideClick: false
            }).then(function (result) {
                if (result.hasOwnProperty('value')) {
                    if (deletePOCResponse.status === 'success') {
                        const index = that.oneUniversity.poc.indexOf(poc);
                        that.oneUniversity.poc.splice(index, 1);
                        if (deletePOCResponse.data.hasOwnProperty('message')) {
                            Swal({
                                title: 'Success',
                                type: 'success',
                                html: deletePOCResponse.data.message,
                            });
                        } else {
                            Swal({
                                title: 'Success',
                                type: 'success',
                                html: '<p>Successfully deleted <span style="font-weight: bold">' + poc.name + '</span> poc?</p>',
                            });
                        }
                    } else if (deletePOCResponse.status === 'fail') {
                        if (deletePOCResponse.data.hasOwnProperty('message')) {
                            Swal({type: 'error', title: 'Fail', html: deletePOCResponse.data.message});
                        } else {
                            Swal({type: 'error', title: 'Fail', text: 'Unable to delete POC, Please contact support team.'});
                        }
                    }
                }
            }, function (cancel) {
                console.log(cancel);
            }).catch(function (error) {
                console.log(error);
            });
        } else {
            const index = this.oneUniversity.poc.indexOf(poc);
            this.oneUniversity.poc.splice(index, 1);
        }
    }

    deleteUniversity(event: Event, university): void {
        event.preventDefault();
        const that = this;
        Swal({
            title: 'confirm',
            type: 'question',
            text: 'Do you want to delete this university?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    const index = that.universities.indexOf(university);
                    that.universities.splice(index, 1);
                    localStorage.setItem('universities', JSON.stringify(that.universities));
                    resolve(true);
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.value === true) {
                that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
                    that.router.navigate(['data/universities']));
                Swal({
                    title: 'Success',
                    type: 'success',
                    width: 600,
                    padding: 80,
                    showCancelButton: false,
                    showConfirmButton: true,
                    html: '<p>Successfully deleted the university.</p>',
                    timer: 1500
                });
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    addEditUniversity(): void {
        if (this.editUniversityFlag === true) {
            this.editUniversity();
        } else {
            this.addUniversity();
        }
    }

    addUniversity(): void {
        this.universities.push(this.oneUniversity);
        localStorage.setItem('universities', JSON.stringify(this.universities));
        Swal({title: 'Success', type: 'success', text: 'University details successfully updated.', timer: 1500});
        this.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
            this.router.navigate(['data/universities']));
        this.universities = JSON.parse(localStorage.getItem('universities'));
        this.closeModal();
    }

    editUniversity(): void {
        const that = this;
        let editResponse;
        const finalUploadData = {
            data: this.oneUniversity,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        Swal({
            title: 'Confirm',
            type: 'question',
            html: '<p>You are going to modify ' + '<span style="font-weight: bold">'
                + this.oneUniversity.university_name + '?</p>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#4cb84c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.bulkUpload(finalUploadData, Constants.EDIT_UNIVERSITY).subscribe(data => {
                        editResponse = data;
                        resolve(editResponse);
                    }, error => {
                        editResponse = error;
                        reject(editResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (editResponse.status === 'success') {
                    that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
                        that.router.navigate(['data/universities']));
                    if (editResponse.data.hasOwnProperty('message')) {
                        Swal({
                            title: 'Success',
                            type: 'success',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: editResponse.data.message,
                            timer: 1500
                        });
                    } else {
                        Swal({
                            title: 'Success',
                            type: 'success',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Successfully Changed University Details.</p>',
                            timer: 1500
                        });
                    }
                    that.closeModal();
                } else if (editResponse.status === 'fail') {
                    if (editResponse.data.hasOwnProperty('message')) {
                        Swal({type: 'error', title: 'Fail', html: editResponse.data.message});
                    } else {
                        Swal({type: 'error', title: 'Fail', text: 'Unable to upload Universities, Please contact support team.'});
                    }
                }
            }
        });
    }

    sendEmailToPOCs(): void {
        Swal({
            title: 'confirm',
            type: 'question',
            text: 'Do you want to send login credentials to university POCs?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    resolve(true);
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.value === true) {
                Swal({title: 'Success', type: 'success', text: 'Login Credentials send successfully.', timer: 1500});
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    openUniversitiesUploadModal() {
        this.modalReference = this.modal.open(this.uploadUniversitiesModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    openUniversityAddModal() {
        this.oneUniversity = {};
        this.modalReference = this.modal.open(this.addEditUniversityModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    openUniversityEditModal(university) {
        this.editUniversityFlag = true;
        this.oneUniversity = {};
        this.dmService.getOne(Constants.UNIVERSITY, university.university_id).subscribe(responseData => {
                if (responseData.status === 'success') {
                    this.oneUniversity = responseData.data.university;
                    if (responseData.data.university.hasOwnProperty('poc')) {
                        this.poc = responseData.data.university.poc;
                        for (let i = 0; i < this.poc.length; i++) {
                            this.poc[i]['old_email'] = this.poc[i].email;
                        }
                    }
                    this.continent = responseData.data.continent;
                    this.country = responseData.data.country;
                    this.oneUniversity.mou_expiry_date = this.oneUniversity.mou_expiry_date !== null
                        ? moment(this.oneUniversity.mou_expiry_date).format('YYYY-MM-DD') : null;
                }
            },
            error => {
                console.log(error);
                this.errorMessage = 'Server Error';
            });
        this.modalReference = this.modal.open(this.addEditUniversityModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    openAdditionalInfoModal(university) {
        this.oneUniversity = university;
        this.modalReference = this.modal.open(this.additionalInfoModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }

    closeModal(): void {
        this.editUniversityFlag = false;
        this.oneUniversity = undefined;
        this.modalReference.close();
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessEC() {
        return this.accessService.canAccessEC();
    }

    ngOnInit() {
        this.getUniversities();
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
    }

}
